import React from "react";
import { PassionSkeleton } from "../Passion/PassionSkeleton";
import { Passion } from "../Passion/Passion";

import styles from "./Passions.module.css";
import { mapPassionsData } from "../../../utils/mapPassionsData";
import { useMatchBreakpoint } from "../../../hooks/useMatchBreakpoint";

export const Passions = (props) => {
  const { passionsData } = props;
  const isInMobilePanel = useMatchBreakpoint(768);

  if (!passionsData) {
    return (
      <ul className={styles.passions}>
        {[null, null, null, null].map((passion, index) => (
          <li key={index} className={styles.passion}>
            <PassionSkeleton passion={passion}></PassionSkeleton>
          </li>
        ))}
      </ul>
    );
  }

  const passions = mapPassionsData(passionsData);

  return (
    <ul className={styles.passions}>
      {passions.map((passion, index) =>
        !isInMobilePanel || passion.value !== "false" ? (
          <li key={index} className={styles.passion}>
            <Passion passion={passion}></Passion>
          </li>
        ) : null,
      )}
    </ul>
  );
};
